/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Preview_Why_HereInputs */

const en_us2_search_preview_why_here = /** @type {(inputs: Search_Preview_Why_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What lives here`)
};

const pt_br2_search_preview_why_here = /** @type {(inputs: Search_Preview_Why_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que fica aqui`)
};

const es_419_search_preview_why_here = /** @type {(inputs: Search_Preview_Why_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qué hay aquí`)
};

const pt_pt2_search_preview_why_here = /** @type {(inputs: Search_Preview_Why_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que fica aqui`)
};

const fr_fr2_search_preview_why_here = /** @type {(inputs: Search_Preview_Why_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce qu'on trouve ici`)
};

const de_de2_search_preview_why_here = /** @type {(inputs: Search_Preview_Why_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was hier liegt`)
};

const it_it2_search_preview_why_here = /** @type {(inputs: Search_Preview_Why_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa trovi qui`)
};

/**
* | output |
* | --- |
* | "What lives here" |
*
* @param {Search_Preview_Why_HereInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_preview_why_here = /** @type {((inputs?: Search_Preview_Why_HereInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Preview_Why_HereInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_preview_why_here(inputs)
	if (locale === "es-419") return es_419_search_preview_why_here(inputs)
	if (locale === "pt-PT") return pt_pt2_search_preview_why_here(inputs)
	if (locale === "fr-FR") return fr_fr2_search_preview_why_here(inputs)
	if (locale === "de-DE") return de_de2_search_preview_why_here(inputs)
	if (locale === "it-IT") return it_it2_search_preview_why_here(inputs)
	return en_us2_search_preview_why_here(inputs)
});
export { search_preview_why_here as "search.preview_why_here" }